import WithPermission from 'Components/SharedComponents/WithPermission/WithPermission'
import { lazy } from 'react'
import NoAccessPage from '../NoAccess/NoAccessPage'

const SettingsContainer = lazy(
  () => import('./SettingsContainer/SettingsContainer')
)
const SettingsPage = lazy(() => import('./SettingsPage/SettingsPage'))
const BillingManagement = lazy(
  () => import('./BillingManagement/BillingManagement')
)

export default {
  path: '/settings',
  exact: false,
  Component: WithPermission(SettingsContainer, ['page:settings'], true),
  access: 'USER',
  routes: [
    {
      path: `/settings`,
      exact: true,
      Component: SettingsPage,
      access: 'USER',
    },
    {
      path: `/settings/notifications`,
      exact: true,
      Component: SettingsPage,
      access: 'User',
    },
    {
      path: `/settings/organization`,
      exact: true,
      Component: WithPermission(
        SettingsPage,
        ['billing:update'],
        false,
        NoAccessPage
      ),
      access: 'User',
    },
    {
      path: `/settings/account`,
      exact: true,
      Component: SettingsPage,
      access: 'User',
    },
    {
      path: `/settings/fundraising`,
      exact: true,
      Component: WithPermission(
        SettingsPage,
        ['billing:update'],
        false,
        NoAccessPage
      ),
      access: 'User',
    },
    {
      path: `/settings/billing`,
      exact: true,
      Component: WithPermission(
        BillingManagement,
        ['page:billing', 'billing:update'],
        false,
        NoAccessPage
      ),
      access: 'User',
    },
  ],
}
